import cn from 'classnames';
import React, { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import styles from './mobile-side-panel.module.scss';

interface MobileSidePanelProps {
    isOpen: boolean;
    className?: string;
    testId?: string;
    portalElement?: Element | DocumentFragment;
}

export const MobileSidePanel = ({
    children,
    testId = 'mobile-side-panel',
    className,
    isOpen,
    portalElement,
}: PropsWithChildren<MobileSidePanelProps>) => {
    const layout = (
        <div
            className={cn(styles.sidePanel, className, {
                [styles.open]: isOpen,
            })}
            data-testid={testId}
        >
            {isOpen && children}
        </div>
    );

    return portalElement ? createPortal(layout, portalElement) : layout;
};
